import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const SchedulesPage = lazy(() => import('~/features/catalog-v2/pages/schedules-page'));

/**
 * Schedules screen state kept in the URL so Back / a shared link restore it: the
 * active tab, list filters + page, the open schedule, and the firings-feed filters.
 * Every key is optional and a bad value falls back to "unset" instead of erroring.
 */
const schedulesSearchSchema = z.object({
  tab: z.enum(['schedules', 'firings', 'tree']).optional().catch(undefined),
  search: z.string().optional().catch(undefined),
  status: z.enum(['ACTIVE', 'PAUSED']).optional().catch(undefined),
  connector: z.string().optional().catch(undefined),
  health: z.enum(['HEALTHY', 'FAILING']).optional().catch(undefined),
  page: z.number().int().min(1).optional().catch(undefined),
  schedule: z.string().optional().catch(undefined),
  feedStatus: z.string().optional().catch(undefined),
  feedConnector: z.string().optional().catch(undefined),
  since: z.string().optional().catch(undefined),
  until: z.string().optional().catch(undefined),
  feedPage: z.number().int().min(1).optional().catch(undefined),
});

export const Route = createFileRoute('/_authenticated/_tenant/catalog-v2/schedules')({
  validateSearch: schedulesSearchSchema,
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <SchedulesPage />
    </Suspense>
  ),
});
